import React, { useState, useEffect } from 'react';
import '../../../assets/css/subscreens/customer/contact/Contactinfo.css';

const Contactinfo = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="contact-info-section">
      <div className="contact-info-container">
        {/* Header */}
        <div className={`contact-info-header ${isVisible ? 'fade-in' : ''}`}>
         
          <h2 className="contact-info-title">Our Contact</h2>
        </div>

        {/* Contact Cards */}
        <div className={`contact-cards-grid ${isVisible ? 'slide-in-up' : ''}`}>
          {/* Phone Card */}
          <div className="contact-card">
            <div className="contact-card-icon-wrapper">
             
              {/* <div className="contact-icon-dots contact-dots-left"></div> */}
            </div>
            <h4 className="contact-card-title">Phone</h4>
            <a href="tel:+923001234567" className="contact-card-link">
              +92 300 123 4567
            </a>
          </div>

          {/* Email Card */}
          <div className="contact-card">
            <div className="contact-card-icon-wrapper">
              {/* <div className="contact-icon-dots contact-dots-left"></div> */}
             
              {/* <div className="contact-icon-dots contact-dots-right"></div> */}
            </div>
            <h4 className="contact-card-title">Email</h4>
            <a href="mailto:info@workhub.com" className="contact-card-link">
              laiba3001@gmail.com
            </a>
          </div>

          {/* Opening Hours Card */}
          <div className="contact-card">
            <div className="contact-card-icon-wrapper">
              {/* <div className="contact-icon-dots contact-dots-right"></div> */}
              
            </div>
            <h4 className="contact-card-title">Opening Hours</h4>
            <p className="contact-card-text">
              09:00 AM – 7:00 PM
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contactinfo;